import AssetsManager from '../../../data/AssetsManager'
import MathUtil from '../../../util/MathUtil'
import BtnView from './BtnView'
import PlayerView from './PlayerView'

/**
 * ShipViewクラス
 */
class ShipView extends PIXI.Container {
  // ---------------------------------------------------------------------------------------------------------
  // --	ShipView
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor() {
    super()

    console.log('ShipView')

    //ミスした時の色の演出
    this.missColors = [0xFFFFFF, 0xffff00, 0xfe050b, 0x0071dd]

    //スケール
    // this.scale.set(2, 2)
    this.scale.set(2.5, 2.5)
    // this.scale.set(3, 3)

    //船
    this.ship = AssetsManager.createSprite("ship.png")
    this.ship.anchor.set(0.5, 0.5)
    this.addChild(this.ship)

    //ヒットエリア配置
    this.ha = new PIXI.Graphics()
    this.ha.beginFill(0x990000)
    this.ha.drawRect(-60, -76, 120, 145)
    this.ha.endFill()
    this.ha.alpha = 0.0
    this.addChild(this.ha)

    //コンテナ配置
    this.conntainer = new PIXI.Container()
    this.conntainer.y = 64
    this.addChild(this.conntainer)

    //プレイヤー
    this.player = new PlayerView()
    this.conntainer.addChild(this.player)

    //ボール配置
    this.ball = AssetsManager.createSprite("ball.png")
    this.ball.anchor.set(0.5, 0.5)
    this.ball.x = 0
    this.ball.y = -123 + 2.5
    this.conntainer.addChild(this.ball)

    //上のヒットエリア
    this.stayArea = new PIXI.Graphics()
    this.stayArea.beginFill(0xffff00)
    this.stayArea.drawRect(0, 0, 34, 3)
    this.stayArea.endFill()
    this.stayArea.x = -17
    this.stayArea.y = -126
    this.conntainer.addChild(this.stayArea)

    this.upHitArea = new PIXI.Graphics()
    this.upHitArea.beginFill(0xfe050b)
    this.upHitArea.drawRect(0, 0, 34, 3)
    this.upHitArea.endFill()
    this.upHitArea.x = -17
    this.upHitArea.y = -126
    this.conntainer.addChild(this.upHitArea)

    //左ボタン
    this.leftBtn = new BtnView()
    this.leftBtn.x = -45
    this.leftBtn.y = -12
    this.conntainer.addChild(this.leftBtn)

    //右ボタン
    this.rightBtn = new BtnView()
    this.rightBtn.x = 45
    this.rightBtn.y = -12
    this.rightBtn.scale.set(-1, 1)
    this.conntainer.addChild(this.rightBtn)

    //右のほのお
    this.rightFire = new PIXI.Container()
    this.addChild(this.rightFire)
    for(let i=0; i<2; i++)
    {
      const fire = AssetsManager.createSprite("fire.png")
      fire.anchor.set(0, 0.5)
      fire.x = 69
      switch (i) {
        case 0:
          fire.y = -56
          break;
        case 1:
          fire.y = 51
          break;
      }
      this.rightFire.addChild(fire)
    }

    //左のほのお
    this.leftFire = new PIXI.Container()
    this.addChild(this.leftFire)
    for(let i=0; i<2; i++)
    {
      const fire = AssetsManager.createSprite("fire.png")
      fire.anchor.set(0, 0.5)
      fire.scale.set(-1, 1)
      fire.x = -69
      switch (i) {
        case 0:
          fire.y = -56
          break;
        case 1:
          fire.y = 51
          break;
      }
      this.leftFire.addChild(fire)
    }

    //下のほのお
    this.bottomFire = new PIXI.Container()
    this.addChild(this.bottomFire)
    for(let i=0; i<3; i++)
    {
      const fire = AssetsManager.createSprite("fire.png")
      fire.anchor.set(0, 0.5)
      fire.rotation = MathUtil.degreeToRadian(90)
      fire.x = -33 + 33 * i
      fire.y = 78
      this.bottomFire.addChild(fire)
    }

    //リセット
    this.reset()
  }

  reset()
  {
    //速度
    this.speed = 1.5
    this.ballSpeedX = 0
    this.ballSpeedY = 0
    this.shipSpeedX = 0
    this.shipSpeedY = 0
    this.missCount = -1

    //ミスの演出停止
    if(this.missTimer)
    {
      this.missTimer.kill()
      this.missTimer = null
    }

    //プレイヤー
    this.player.reset()

    //宇宙船の色
    this.ship.tint = 0x0071dd

    //ヒットエリア非表示
    this.upHitArea.visible = false

    //ボタンの状態
    this.leftBtn.reset()
    this.rightBtn.reset()

    //ほのお非表示
    this.leftFire.visible = false
    this.rightFire.visible = false
    this.bottomFire.visible = false

    //ボールリセット
    this.ball.x = 0
    this.ball.y = -123 + 2.5
    this.ball.visible = false

    //非表示
    this.visible = false
  }

  // --------------------------------------------------------------------------------------------------------------------------------------
	// --	 スタート
  // --------------------------------------------------------------------------------------------------------------------------------------

  start()
  {
    //表示
    this.visible = true

    //ボール表示
    gsap.delayedCall(1.0, this.playBall.bind(this))
  }

  playBall()
  {
    //初期位置
    this.ball.x = -20 + Math.random()*40

    //速度
    const radian = MathUtil.degreeToRadian(45 + Math.random()*90)
    this.ballSpeedX = Math.cos(radian) * this.speed
    this.ballSpeedY = Math.sin(radian) * this.speed

    //表示
    this.ball.visible = true
  }


  // --------------------------------------------------------------------------------------------------------------------------------------
	// --	 アップデート
  // --------------------------------------------------------------------------------------------------------------------------------------

  /**
   * アップデート
   */
  update(playerSpeed)
  {
    //プレイヤーのアップデート
    this.updatePlayer(playerSpeed)

    //ボールのアップデート
    this.updateBall()

    //SE
    if(this.leftFire.visible || this.rightFire.visible || this.bottomFire.visible)
    {
      AssetsManager.playSound('sound_jet', true, 0.5)
    }
    else
    {
      AssetsManager.stopSound('sound_jet')
    }
  }

  /**
   * プレイヤーアップデート
   */
  updatePlayer(playerSpeed)
  {
    //速度
    this.player.x += playerSpeed

    //左のボタンおす
    if(this.player.x <= -33)
    {
      AssetsManager.stopSound('sound_walk')
      this.player.x = -33
      this.player.pushLeftBtn()
      this.leftBtn.press()
      this.leftFire.visible = true
      this.shipSpeedX = 2
    }
    //右のボタンおす
    else if(this.player.x >= 33)
    {
      AssetsManager.stopSound('sound_walk')
      this.player.x = 33
      this.player.pushRightBtn()
      this.rightBtn.press()
      this.rightFire.visible = true
      this.shipSpeedX = -2
    }
    //通常
    else
    {
      if(playerSpeed == 0)
      {
        AssetsManager.stopSound('sound_walk')
        this.player.stay()
      }
      else
      {
        AssetsManager.playSound('sound_walk', true, 0.1)
        this.player.walk()
      }
      this.leftBtn.reset()
      this.rightBtn.reset()
      this.leftFire.visible = false
      this.rightFire.visible = false
      this.shipSpeedX = 0
    }
  }

  /**
   * ボールアップデート
   */
  updateBall()
  {
    //移動
    this.ball.x += this.ballSpeedX
    this.ball.y += this.ballSpeedY

    //プレイヤーとの当たり判定
    if(this.hitTestPlayer())
    {
      //SE
      AssetsManager.playSound('sound_pong')

      //跳ね返る
      this.ball.y = this.player.y - 2.5
      this.ballSpeedY *= -1

      //角度を少しずらす
      let degree = MathUtil.getDegree(new PIXI.Point, new PIXI.Point(this.ballSpeedX, this.ballSpeedY))
      degree += -30 + Math.random()*60
      if(degree > - 25)
      {
        degree = -25
      }
      else if(degree < -155)
      {
        degree = -155
      }
      const radian = MathUtil.degreeToRadian(degree)

      this.speed += 0.001
      this.ballSpeedX = Math.cos(radian) * this.speed
      this.ballSpeedY = Math.sin(radian) * this.speed
    }

    //左の壁
    if(this.ball.x <= -37.5 && this.ballSpeedX < 0)
    {
      //SE
      AssetsManager.playSound('sound_pong')

      this.ball.x = -37.5
      this.ballSpeedX *= -1
    }
    //右の壁
    else if(this.ball.x >= 37.5 && this.ballSpeedX > 0)
    {
      //SE
      AssetsManager.playSound('sound_pong')

      this.ball.x = 37.5
      this.ballSpeedX *= -1
    }
    //天井
    else if(this.ball.y <= -120.5 && this.ballSpeedY < 0)
    {
      //SE
      AssetsManager.playSound('sound_pong')

      this.ball.y = -120.5
      this.ballSpeedY *= -1

      if(Math.abs(this.ball.x) <= 19)
      {
        this.shipSpeedY = 2
        this.bottomFire.visible = true
        this.upHitArea.visible = true
        gsap.delayedCall(2, ()=>{
          this.shipSpeedY = 0
          this.bottomFire.visible = false
          this.upHitArea.visible = false
        })
      }
    }
    //床
    else if(this.ball.y >= -2.5 && this.ballSpeedY > 0)
    {
      this.ball.y = -2.5
      this.emit('MISS')
    }
  }

  /**
   * プレイヤーとの当たり判定
   */
  hitTestPlayer()
  {
    //プレイヤーのX座標の差
    let saX = Math.abs(this.player.x - this.ball.x)

    return (this.ball.y >= this.player.y - 2.5 && this.ball.y <= this.player.y && saX <= 15 && this.ballSpeedY > 0)
    // return (this.ball.y >= this.player.y - 2.5 && this.ball.y <= this.player.y && saX <= 150 && this.ballSpeedY > 0)
  }
  

  // --------------------------------------------------------------------------------------------------------------------------------------
	// --	 ミスした時の演出
  // --------------------------------------------------------------------------------------------------------------------------------------

  miss()
  {
    this.missCount = 0
    this.player.miss()
    this.missAnimation()
  }

  missAnimation()
  {
    this.missCount ++
    const color = this.missColors[this.missCount%4]
    this.ship.tint = color

    if(this.missCount <= 20)
    {
      this.missTimer = gsap.delayedCall(0.02, ()=>{
        this.missAnimation()
      })
    }
    else
    {
      this.missTimer = null
      this.ship.tint = 0x0071dd
    }
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default ShipView
